import { normalizeApiDate } from './date-formatter';

/**
 * The minimum operation date for a ranked portfolio
 *
 */
export const getListedPortfolioEarliestOperationDate = {
  methods: {
    getListedPortfolioEarliestOperationDate() {
      const daysToSubstract = 2;
      let earliestDate = this.$dayjs().subtract(daysToSubstract, 'day');

      switch (earliestDate.day()) {
        case 0:
          // Sunday
          earliestDate = earliestDate.subtract(2, 'day');
          break;
        case 6:
          // Saturday
          earliestDate = earliestDate.subtract(2, 'day');
          break;
        default:
          break;
      }
      return earliestDate.format('YYYY-MM-DD');
    },
  },
};

/**
 * Formats an API date as a relative time string (e.g. "2 hours ago").
 *
 * Missing dates, including DateTime.MinValue, return null so callers can conditionally hide the corresponding UI element.
 *
 * @param date - An ISO date string received from the API.
 * @param dayjs - The application's configured Day.js factory.
 * @returns The relative time string, or null if the date is missing.
 */
// Note - Might want to move this in a more generic date utility file.
export const getDateFromNow = (date, dayjs) => {
  // TODO from Julien: we can remove this workaround once the API returns null for missing dates.
  const normalizedDate = normalizeApiDate(date);

  return normalizedDate ? dayjs(normalizedDate).fromNow() : null;
};
